import { nextTick } from 'vue';
import { initScrollAnimations } from '../utils/scrollAnimations';

export default {
  mounted() {
    nextTick(() => {
      if (this.scrollRevealEnabled === false) return;
      this.__scrollCleanup = initScrollAnimations(this.$el);
    });
  },
  beforeUnmount() {
    if (this.__scrollCleanup) {
      this.__scrollCleanup();
      this.__scrollCleanup = null;
    }
  },
  methods: {
    // Re-scan after the DOM changes (e.g. a collapsed group is expanded), so newly
    // shown elements are observed and anything already in view is revealed.
    refreshScrollReveal() {
      nextTick(() => {
        if (this.__scrollCleanup) this.__scrollCleanup();
        this.__scrollCleanup = initScrollAnimations(this.$el);
      });
    }
  }
};
